import React from "react";

import { withApollo } from "../lib/apollo3";
import { SearchPageLayout_v3 } from "RefactorSearchPage/SearchPageLayout_v3";
import { ThemeProvider } from "shared-components/Contexts/Theme/context";
import getConfig from "next/config"
import { decodeHashUrl } from "@Utils/Functions";
import { FiltersContextProvider } from "shared-components/Contexts/Filters/context";
import { ConfigurationsProvider } from "shared-components/Contexts/Configurations/context";
import { AuthModalProvider } from "shared-components/Components/User/AuthModal/web";
import { UserInitialFetch } from "lib/auth";
import { GlobalComponents } from "shared-components/ViewFragments/GlobalComponents/GlobalComponents";
import { UserProvider } from "shared-components/Contexts/User/context";

const { APP_THEME } = getConfig().publicRuntimeConfig;

// SearchPage Page
const SearchPage = (props) => {

	return <>
		<ThemeProvider active={true} APP_THEME={APP_THEME}>
			<ConfigurationsProvider active={true} initialState={props?.ConfigContextInitialState}>
				<FiltersContextProvider active={true} initialState={props?.FiltersContextInitialState}>

					<UserProvider active={true} initialState={null}>
						<GlobalComponents>
							<AuthModalProvider />
							<UserInitialFetch />
							<SearchPageLayout_v3 />
						</GlobalComponents>
					</UserProvider>

				</FiltersContextProvider>
			</ConfigurationsProvider>
		</ThemeProvider>
	</>
};

SearchPage.getInitialProps = async function ({ req, query, res, asPath, apolloClient, ...rest }) {
	const q = decodeHashUrl(query.hashed);
	return {
		params: q,
		FiltersContextInitialState: q.filters,
		ConfigContextInitialState: q?.configs
	};
};

export default withApollo(
	SearchPage
);

